import { RouteCreatedEvent } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/route_events_pb';
import { RouteStatus } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/route_pb';
import {
  BadgeField,
  Col,
  FieldDisplay,
  IDField,
  ThemeColor,
} from '@rematter/ui-web';

import { routeStatusLabels } from '../enumLabels';

const getStatusColor = (status: RouteStatus): ThemeColor => {
  switch (status) {
    case RouteStatus.PLANNED:
      return 'warning';
    case RouteStatus.ACTIVE:
      return 'success';
    case RouteStatus.COMPLETED:
      return 'teal';
    case RouteStatus.FAILED:
      return 'failure';
    case RouteStatus.VOIDED:
      return 'neutral';
    default:
      return 'neutral';
  }
};

type RouteCreatedDetailProps = {
  event: RouteCreatedEvent;
};

export const RouteCreatedDetail = ({ event }: RouteCreatedDetailProps) => {
  const route = event.route;

  if (!route) {
    return (
      <Col className="@RouteCreatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@RouteCreatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Route Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={route.id?.value} />
          <FieldDisplay
            label="Document Number"
            value={route.documentNumber ? String(route.documentNumber) : ''}
          />
          <BadgeField
            label="Status"
            value={routeStatusLabels[route.status]}
            color={getStatusColor(route.status)}
          />
          <FieldDisplay label="Rank" value={route.rank} />
          <FieldDisplay
            label="Priority"
            value={route.priority ? String(route.priority) : ''}
          />
          <FieldDisplay label="Description" value={route.description} />
          <FieldDisplay label="Notes" value={route.notes} />
          <IDField label="Driver ID" value={route.driverId?.value} />
          <IDField label="Hauler ID" value={route.haulerId?.value} />
          <IDField label="Truck ID" value={route.truckId?.value} />
          <IDField label="Trailer ID" value={route.trailerId?.value} />
          <IDField
            label="Facility Group ID"
            value={route.facilityGroupId?.value}
          />
        </div>
      </Col>
    </Col>
  );
};
